<div class="bar-charts" id="bargraph{{pageTab}}{{index}}"></div>